import home from "./pages/home";
import careers from "./pages/careers";
export const allRoutes = [
  {
    path: "/home",
    component: home,
    exact: true,
  },
  {
    path: "/careers",
    component: careers,
    exact: true,
  }
];